"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN = void 0;
const react_1 = __importStar(require("react"));
const AdminLayout_1 = __importDefault(require("../../components/AdminLayout"));
const react_router_dom_1 = require("react-router-dom");
const root_1 = require("../root");
const menu_1 = require("./menu");
const notFound_1 = __importDefault(require("../notFound"));
const index_1 = require("../index");
const auth_1 = require("common/auth");
const function_client_1 = require("common/function-client");
const auth_2 = require("firebase/auth");
const firebaseApp_1 = __importDefault(require("@/firebaseApp"));
exports.ADMIN = root_1.ROOT.sub("/admin", Admin, {
    parent: true,
    components: { menu: menu_1.AdminMenu },
});
const auth = (0, auth_2.getAuth)(firebaseApp_1.default);
function Admin() {
    const login = (0, index_1.resolveRoute)("LOGIN");
    const { data: user } = (0, auth_1.useIdTokenResult)();
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = user === null || user === void 0 ? void 0 : user.uid) === null || _a === void 0 ? void 0 : _a.includes("si-integration")) {
            (0, function_client_1.revalidateExternalAuthorization)().catch((error) => {
                auth.signOut();
                console.error(error);
            });
            const interval = setInterval(() => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield (0, function_client_1.revalidateExternalAuthorization)();
                }
                catch (error) {
                    auth.signOut();
                    console.error(error);
                }
            }), 60 * 1000);
            return () => clearInterval(interval);
        }
    }, [user === null || user === void 0 ? void 0 : user.uid]);
    return (react_1.default.createElement(AdminLayout_1.default, { NotFoundComp: (0, notFound_1.default)(), loginRoute: login },
        react_1.default.createElement(react_router_dom_1.Outlet, null)));
}
